export default "__VITE_ASSET__NyKztUvf__"